var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"overlay"}},[_c('div',{attrs:{"id":"lef"}},[_c('img',{attrs:{"id":"leftImage","alt":"暂无图片","src":_vm.img1Src}})]),_c('div',{attrs:{"id":"rit"}},[_c('img',{attrs:{"id":"topImage","alt":"暂无图片","src":_vm.img2Src}}),_c('label',{attrs:{"id":"overlayName"}},[_vm._v(_vm._s(_vm.overlayName))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }